<template>
  <div>
    <button style="padding: 0.5rem;" class="btn" @click="openModal()">
      <i class="fa-regular fa-gear"></i>
    </button>
    <!-- modal allocate viban -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Configure: {{ config.title }}<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <small style="color: #717182; font-weight: normal;">Adjust the parameters for this reconciliation rule.</small>

        <div class="info-container">
          <i style="color: #1c398e;" class="fa-regular fa-circle-info"></i>
          <span>{{ config.description }}</span>
        </div>

        <div style="display: grid; background-color: #fbf9fa !important; padding: 1rem; border-radius: .625rem; margin: 1rem 0rem; row-gap: 0.5rem;" v-for="(item, index) in Object.entries(newRules.param)" :key="index">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: grid;">
              <span style="font-weight: bold;">{{ item[0].split('_').map(e => {return e.slice(0,1).toUpperCase() + e.slice(1)}).join(' ') }}</span>
              <small style="color: #4a5565;" v-if="item[1].description">{{ item[1].description }}</small>
            </div>
            <div v-if="item[1].type == 'boolean'">
              <div @click="() => item[1].value = !item[1].value" :style="{display: 'flex','justify-content': item[1].value ? 'end' : 'left', 'border-radius': '50px', 'height': '1rem', 'width': '2rem', 'background-color': item[1].value ? 'black' : 'gray'}"><div  style="border-radius: 50px; width: 1rem; height: 1rem; background-color: white;"></div></div>
            </div>
            <div v-else-if="item[1].type == 'number'">
              <input type="number" class="filter-item-content" :placeholder="item[1].value" @input="event => item[1].value = event.target.value">
            </div>
            <div v-else>
              <a :id="`${item[0]}-picker-link`"
                class="filter-item-content d-flex justify-content-between py-2 px-3"
                href="#">
                <span class="fixed-span-size">{{ item[1].value }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
              </a>
              <b-popover :target="`${item[0]}-picker-link`" triggers="focus" placement="bottom" custom-class="popover">
                <div>
                  <span v-for="(option, index) in item[1].options" :key="index" :class="['popover-option', {'popover-option-selected':  option == item[1].value}]" @click="() => item[1].value = option">
                    {{ option }}
                  </span>
                </div>
              </b-popover>
            </div>
          </div>
          <small style="color: #4a5565;" v-if="item[1].example"> <small style="color: #155dfc;">Example:</small> {{ item[1].example }}</small>
          <small style="color: #4a5565;" v-if="item[1].impact"> <small style="color: #e17100;">Impact:</small> {{ item[1].impact }}</small>
        </div>

        <div class="modal-content-buttons" >
          <button class="btn-outline-light btn" @click="closeModal()">Cancel</button>
          <button class="btn-outline btn-dark" @click="saveChanges()">Apply Changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfigurationModal',
  emits: ['update'],
  props: {
    config: Object
  },
  data(){
    return{
      isModalOpen: false,
      newRules: []
    }
  },
  methods: {
    openModal () {
      this.isModalOpen = true
      this.newRules = structuredClone(this.config)
    },
    closeModal () {
      this.newRules = structuredClone(this.config)
      this.isModalOpen = false
    },
    saveChanges () {
      this.$emit('update', this.newRules)
      this.isModalOpen = false
    }
  }
}
</script>

<style scoped>
 .info-container{
    background-color: #eef2ff80;
    border: 1px solid #bfdbfe;
    color: #717182;
    padding: 1rem;
    border-radius: .625rem;
    margin: 1rem 0rem;
    display: flex;
    align-items: baseline;
    gap: 1rem;
  }
</style>